//reduxは使っていないのでstore管理（ユーザー情報）は独自実装 store/user.js
import React from 'react';
import ReactDOM from 'react-dom';

import demo from './demo';
import lp from './lp';
import lpThanks from './lpThanks';
import lpLogin from './lpLogin';
import topUser1 from './topUser1';
import topUser4 from './topUser4';
import loading from './loading';

import newEdit from './newEdit';

import newflow1 from './newflow1';
import newflow3 from './newflow3';
import newflow5 from './newflow5';
import newflow8 from './newflow8';
import newflow10 from './newflow10';
// MyRate保険は2019年3月末リリースに含めない
// import getInsurance from './getInsurance';

import emailRegister from './email_register'
import emailRegister2 from './email_register2'
import passwordRegister from './passwordRegister';
import namesRegister from './namesRegister';
import signUp from './signUp';
import oauthAuthorize from './oauthAuthorize';
import oauthLogin from './oauthLogin';

import top from './top';
import passwordChange from './passwordChange';

import auth from './auth';
import personIdentification from './personIdentification';
import personIdentification1 from './personIdentification1';
import error404 from './error404';
import passwordReset1 from './passwordReset1';
import passwordReset2 from './passwordReset2';

import { Router, Route, browserHistory } from 'react-router';

import /*register,*/{unregister} from './registerServiceWorker';
unregister();

ReactDOM.render(
    <Router history={browserHistory}>
        <Route path='/oauthAurhorize' component={oauthAuthorize} />
        <Route path='/oauthLogin' component={oauthLogin} />

        <Route path='/password_reset1' component={passwordReset1} />
        <Route path='/password_reset2' component={passwordReset2} />
        <Route path="/demo" component={demo} />
        {/* MyRate保険は2019年3月末リリースに含めない */}
        {/* <Route path="/insurance" component={getInsurance} /> */}
        <Route path="/user" component={topUser1} >
            <Route path="/user/:uid" component={topUser1} />
        </Route>
        <Route path="/lp" component={lp} />
        <Route path="/lpThanks" component={lpThanks} />
        <Route path="/lpLogin" component={lpLogin} />
        <Route path="/topUser4" component={topUser4} />
        <Route path="/loading" component={loading} />

        <Route path="/newEdit" component={newEdit} />

        <Route path="/newflow1" component={newflow1} />
        <Route path="/newflow3" component={newflow3} />
        <Route path="/newflow6" component={newflow5} />
        <Route path="/newflow8" component={newflow8} />
        <Route path="/newflow10" component={newflow10} />
        <Route path="/email_register" component={emailRegister} />
        <Route path="/email_register2" component={emailRegister2} />
        <Route path="/passwordRegister" component={passwordRegister} />
        <Route path="/namesRegister" component={namesRegister} />

        <Route path="/top" component={top} />
        <Route path="/" component={top} />

        <Route path="/newflow5" component={signUp} />
        <Route path="/passwordChange" component={passwordChange} />


        <Route path="/auth/:id/:cid" component={auth} />
        <Route path="/personIdentification/:id" component={personIdentification} />
        <Route path="/personIdentification1" component={personIdentification1} />
        <Route path="/404" component={error404} />
        <Route path='*' exact={true} component={error404} />

    </Router>, document.getElementById('root')
);


// WEBPACK FOOTER //
// ./src/index.js